module.exports = __webpack_public_path__ + "static/media/MainPage.bcf74cbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MainPage.jpg
// module id = 257
// module chunks = 0